// @flow
import { compose } from "redux";
import { connect } from "react-redux";

import modularui from "../_modularui/ModularUIConnector";

import { HTTP_METHODS } from "../../constants/Constants";
import { getSetting } from "../../constants/Settings";

import { cancelForm, previousObject } from "../actions/Form";
import { showFormNotification } from "../actions/Notification";

import Href from "../../models/href/Href";

import type { AbstractComponent } from "react";
import type FormModel from "../../models/form/FormModel";
import type { ContextRouter } from "react-router";
import type { ReduxState, ThunkAction } from "../types";
import type { ModularUIConnector, UpdateFormAction } from "../_modularui/types";

type OwnProps = {
  ...?ContextRouter,
  href?: Href,
  isModal?: boolean,
  redirectTo?: string,
};

type StateProps = {
  isModal: boolean,
};

type DispatchProps = {
  onPrevious: (form: FormModel) => UpdateFormAction,
  onCancel: (form: FormModel) => ThunkAction<>,
  showFormNotification: (form: FormModel) => ThunkAction<>,
};

type Props = {
  ...OwnProps,
  ...StateProps,
  ...DispatchProps,
};

const mapStateToProps = (
  state: ReduxState,
  ownProps: OwnProps,
): StateProps => ({
  isModal: state.router.location?.state?.modal || ownProps.isModal || false,
});

const mapDispatchToProps: DispatchProps = {
  onPrevious: previousObject,
  onCancel: cancelForm,
  showFormNotification,
};

const reduxConnectedForm = connect<Props, OwnProps, StateProps, _, _, _>(
  mapStateToProps,
  mapDispatchToProps,
);

const moduiConnectedForm: ModularUIConnector = modularui(
  "Form",
  ({ href, location }) => {
    const formHref = href || new Href(`${location.pathname}${location.search}`);

    if (getSetting("ALWAYS_COMMIT_FORM")) {
      return formHref;
    }

    return formHref.addParameter("commit", "false");
  },
  { propName: "form", method: HTTP_METHODS.POST },
);

/**
 * @deprecated - will be removed in the future, use the equivalent hook 'useForm' instead
 */
export const connectForm: (
  Component: AbstractComponent<Props>,
) => AbstractComponent<OwnProps> = compose(
  moduiConnectedForm,
  reduxConnectedForm,
);
